import React from 'react';

const container = {
  minHeight: '100vh',
  background: '#050516',
  color: '#e2e8f0',
  fontFamily: 'sans-serif',
};
const card = {
  maxWidth: 900,
  margin: '0 auto',
  padding: '40px 24px 60px',
};
const section = { marginBottom: 28 };
const h1 = { fontSize: 26, marginBottom: 8 };
const h2 = { fontSize: 18, marginBottom: 6, marginTop: 20 };
const p = { color: '#94a3b8', fontSize: 14, lineHeight: 1.7, margin: '4px 0' };
const li = { color: '#94a3b8', fontSize: 14, lineHeight: 1.7, margin: '4px 0 0 18px' };

export default function TermsPage() {
  return (
    <div style={container}>
      <div style={{ borderBottom: '1px solid #1f2937', padding: '16px 32px' }}>
        <span style={{ color: '#6366f1', fontWeight: 800, fontSize: 20 }}>SPECTRAINE</span>
      </div>

      <main style={card}>
        <header style={section}>
          <h1 style={h1}>Terms of Service</h1>
          <p style={{ ...p, marginTop: 4 }}>Last updated: 26 March 2026</p>
          <p style={p}>
            These Terms of Service (“Terms”) govern your access to and use of the Spectraine service (“Service”). By creating an account or using the Service, you agree to these Terms.
          </p>
        </header>

        <section style={section}>
          <h2 style={h2}>1. Service description</h2>
          <p style={p}>
            Spectraine provides AWS security posture analysis, cost optimisation insights, and related reporting based on read‑only access to your AWS environment.
          </p>
          <p style={p}>
            You remain responsible for your own AWS configuration, security controls, and costs. Spectraine provides recommendations, but does not make changes in your AWS account.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>2. Eligibility and accounts</h2>
          <p style={p}>
            You must be at least 18 years old and authorised to act on behalf of your organisation. You are responsible for:
          </p>
          <ul style={{ paddingLeft: 0, listStyle: 'disc' }}>
            <li style={li}>Ensuring registration information is accurate and kept up to date.</li>
            <li style={li}>Maintaining the confidentiality of your login credentials.</li>
            <li style={li}>All activity under your account.</li>
          </ul>
        </section>

        <section style={section}>
          <h2 style={h2}>3. Fees, billing and trials</h2>
          <p style={p}>
            Paid subscriptions are billed in advance on a recurring basis (e.g. monthly) via Stripe. Fees and plans are shown on our pricing page at the time of purchase.
          </p>
          <p style={p}>
            Subscriptions automatically renew unless cancelled via the billing portal or in‑app controls. We may change pricing with prior notice; changes do not affect the current billing period.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>4. AWS access and responsibility</h2>
          <p style={p}>
            You connect the Service to your AWS account using an IAM role with read‑only permissions and a unique External ID. You remain solely responsible for:
          </p>
          <ul style={{ paddingLeft: 0, listStyle: 'disc' }}>
            <li style={li}>Creating, reviewing, and managing the IAM role and its permissions.</li>
            <li style={li}>Any actions taken in your AWS account based on our recommendations.</li>
            <li style={li}>Compliance with AWS terms and any applicable security or regulatory requirements.</li>
          </ul>
        </section>

        <section style={section}>
          <h2 style={h2}>5. Acceptable use</h2>
          <p style={p}>You agree not to:</p>
          <ul style={{ paddingLeft: 0, listStyle: 'disc' }}>
            <li style={li}>Use the Service for unlawful, harmful, or abusive purposes.</li>
            <li style={li}>Attempt to gain unauthorised access to our systems or other customers’ data.</li>
            <li style={li}>Reverse engineer, copy, or resell the Service without our written consent.</li>
          </ul>
        </section>

        <section style={section}>
          <h2 style={h2}>6. Data protection</h2>
          <p style={p}>
            Our handling of personal data is described in our Privacy Policy. By using the Service you agree to that policy and any applicable data processing terms agreed with your organisation.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>7. Service availability and changes</h2>
          <p style={p}>
            We aim to provide a reliable service but do not guarantee uninterrupted availability. We may modify, suspend, or discontinue parts of the Service with reasonable notice where practicable.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>8. Disclaimer</h2>
          <p style={p}>
            The Service is provided “as is” without warranties of any kind, whether express or implied, including fitness for a particular purpose or non‑infringement.
          </p>
          <p style={p}>
            Security and cost recommendations are based on the information available at the time of the scan and do not constitute legal, compliance, or financial advice.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>9. Limitation of liability</h2>
          <p style={p}>
            To the maximum extent permitted by law, Spectraine is not liable for indirect, incidental, special, or consequential damages, loss of profits, or loss of data arising from use of the Service.
          </p>
          <p style={p}>
            Our total aggregate liability in connection with the Service is limited to the fees paid by you for the Service in the 3 months preceding the event giving rise to the claim.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>10. Termination</h2>
          <p style={p}>
            You may cancel your subscription at any time via the billing portal or in‑app controls. We may suspend or terminate your access if you breach these Terms or misuse the Service.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>11. Changes to these Terms</h2>
          <p style={p}>
            We may update these Terms from time to time. If changes are material, we will provide notice (for example by email or in‑app). Continued use of the Service after changes take effect constitutes acceptance of the updated Terms.
          </p>
        </section>

        <section style={section}>
          <h2 style={h2}>12. Contact</h2>
          <p style={p}>
            For questions about these Terms, contact:
          </p>
          <p style={p}>
            Email: <a href="mailto:andrei@spectraine.com" style={{ color: '#6366f1' }}>andrei@spectraine.com</a>
          </p>
        </section>
      </main>
    </div>
  );
}